<script setup>

import {computed, reactive, ref} from "vue";

const props = defineProps({
    readOnly: {
        type: Boolean,
        default: false,
    },
})

const displayCreateNew = ref(false)
const state = ref('')

const newAutomationOptions = reactive({
    name: '',
});

const createAutomation = async () => {
    if (state.value !== '' || ! newAutomationValidates) {
        return;
    }
    state.value = 'working';
    try {
        const res = await axios.post(route('api.bo.crm.automation.store'), {
            name: newAutomationOptions.name,
        });

        if (res.data.success) {
            state.value = 'success'
            window.location.href = route('bo.crm.automations.edit', res.data.automation.id);
        } else {
            state.value = 'error'
        }
    } catch (error) {
        state.value = 'error'
    }
}

const newAutomationValidates = computed(() => {
    return newAutomationOptions.name.trim() !== '';
})

</script>
<template>
    <div class="md:sticky top-2 z-topbar">
        <frosted-bar>
            <div class="flex items-center justify-between space-x-4">
                <h1>
                    {{ _mft('communication:automation.domainNamePlural') }}
                </h1>

                <div class="flex items-center space-x-2">
                    <story-lane-modal :module="'automations-v4'"></story-lane-modal>
                    <a
                        :href="route('crm.communications.settings.show')"
                    >
                        <button-secondary>
                            {{ _mft('communication:settings') }}
                        </button-secondary>
                    </a>
                    <button-primary
                        v-if="!readOnly"
                        @click="displayCreateNew = true"
                    >
                        {{ _mft('communication:automation.createNew') }}
                    </button-primary>
                </div>
            </div>
        </frosted-bar>
    </div>

    <div v-if="readOnly" class="mt-4 mx-4 p-4 bg-blue-50 border border-blue-200 rounded-lg text-blue-800 text-sm">
        These are legacy automations. New automations should be created in <a :href="route('bo.crm.workflows.index')" class="mf-link font-medium">Workflows</a>.
    </div>

    <div class="mt-12">
        <communication-index
            type="automation"
            :version="4"
        ></communication-index>

        <slideout-with-slots
            v-if="displayCreateNew"
            @close="displayCreateNew = false"
        >
            <template #title>
                <h1>{{ _mft('communication:automation.createNew') }}</h1>
            </template>
            <template #body>
                <div>
                    <input-text
                        v-model:content="newAutomationOptions.name"
                        :label="_mft('communication:automationName')"
                        maxlength="250"
                        :autofocus="true"
                    />

                    <div class="flex justify-end mt-8">
                        <button-success
                            :disabled="! newAutomationValidates"
                            :state="state"
                            @click="createAutomation"
                        >
                            {{ _mft('shared:action.create')}}
                        </button-success>
                    </div>

                </div>
            </template>
        </slideout-with-slots>
    </div>
</template>
